// voiceEntryActions.ts
import { voiceEntryActionTypes } from "./voiceEntryTypes";

// Action to handle API success
export const voiceEntryApiResponseSuccess = (actionType: string, data: any) => ({
  type: voiceEntryActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Action to handle API error
export const voiceEntryApiResponseError = (actionType: string, error: string) => ({
  type: voiceEntryActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});
/**
 * Action: SET_RECORDING_STATUS
 * Description: Sets the recording status in the state.
 * Impacted Variables: recordingStatus
 */
export const setRecordingStatus = (recordingStatus: boolean) => ({
  type: voiceEntryActionTypes.SET_RECORDING_STATUS,
  payload: recordingStatus,
});
/**
 * Action: SET_REMAINING_TIME
 * Description: Sets the remaining time in the state.
 * Impacted Variables: remainingTime
 */
export const setRemainingTime = (remainingTime: number) => ({
  type: voiceEntryActionTypes.SET_REMAINING_TIME,
  payload: remainingTime,
});
/**
 * Action: RESET_REMAINING_TIME
 * Description: Resets the remaining time to the initial value (30 seconds).
 * Impacted Variables: remainingTime
 */
export const resetRemainingTime = () => ({
  type: voiceEntryActionTypes.RESET_REMAINING_TIME,
});
/**
 * Action: SET_PROCESSING_STATUS
 * Description: Sets the processing status in the state.
 * Impacted Variables: processingStatus
 */
export const setProcessingStatus = (processingStatus: string) => ({
  type: voiceEntryActionTypes.SET_PROCESSING_STATUS,
  payload: processingStatus,
});
/**
 * Action: SUBMIT_AUDIO_ENTRY
 * Description: Submits the recorded audio to the backend for LLM processing.
 * Impacted Variables: sqlResult, entryResult, errorMessage
 */
// export const submitAudioEntry = (file: File) => ({
//   type: voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY,
//   payload: file,
// });

export const submitAudioEntry = (payload: { file: File; fileType: string }) => ({
  type: voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY,
  payload,
});

/**
 * Action: CLEAR_ENTRY_RESULTS
 * Description: Clears the SQL result and entry data.
 * Impacted Variables: sqlResult, entryResult
 */
export const clearEntryResults = () => ({
  type: voiceEntryActionTypes.CLEAR_ENTRY_RESULTS,
});
/**
 * Action: SET_ERROR_MESSAGE
 * Description: Sets the error message in the state.
 * Impacted Variables: errorMessage
 */
export const setErrorMessage = (errorMessage: string) => ({
  type: voiceEntryActionTypes.SET_ERROR_MESSAGE,
  payload: errorMessage,
});




export const updateAudioEntry = (payload: { file: File; fileType: string, previousEntryResult?: any }) => ({
  type: voiceEntryActionTypes.UPDATE_AUDIO_ENTRY,
  payload,
});



  /**
   * @description Clears the error message from the Redux state.
   * @impact errorMessage - Resets the errorMessage to null.
   */
  export const approvedEntrySubmit = (data: any) => ({
    type: voiceEntryActionTypes.APPROVED_ENTRY_SUBMIT,
    payload: data
  });
